import {Component, EventEmitter, Input, OnInit, Output, Renderer2} from '@angular/core';
import {EmojiDto, EMOJIS} from '../../models/card.model';

@Component({
  selector: 'app-emojis',
  templateUrl: './emojis.component.html',
  styleUrls: ['./emojis.component.scss'],
})
export class EmojisComponent implements OnInit {
  @Output() onSubmit = new EventEmitter<string>();

  @Input() set emoji(emoji: EmojiDto) {
    if (emoji !== null && emoji !== undefined) {
      if (!this.timeoutReceive) {
        this.timeoutReceive = setTimeout(() => {
          this.displayEmoji(emoji.name);
          this.timeoutReceive = null;
        }, 200);
      }
    }
  }
  @Input() container!: HTMLElement;

  emojis = EMOJIS;
  timeMultiplier: number = 0.8;

  timeoutReceive = null;
  timeoutEmit = null;


  constructor(private renderer: Renderer2) {
  }

  ngOnInit() {
    if (this.container) {
      console.log('Container received:', this.container);
    } else {
      console.error('No container provided!');
    }
  }

  displayEmoji(name: string) {
    const emoji = EMOJIS.find(e => e.name === name);
    if (!emoji) {
      console.error('Emoji not found:', name);
      return;
    }

    // Create the wrapper and emoji elements
    const wrapperElement = this.renderer.createElement('div');
    const emojiElement = this.renderer.createElement('div');
    const text = this.renderer.createText(emoji.code);

    const startX = this.container.offsetWidth - 120;
    const startY = '150';
    const horizontalRange = 200;

    // Set up the wrapper
    this.renderer.addClass(wrapperElement, 'emoji-wrapper');
    this.renderer.setStyle(wrapperElement, 'position', 'absolute');
    this.renderer.setStyle(wrapperElement, 'left', `${startX}px`);
    this.renderer.setStyle(wrapperElement, 'bottom', `${startY}px`);

    // Set up the emoji
    this.renderer.addClass(emojiElement, 'emoji');
    this.renderer.appendChild(emojiElement, text);

    // Append emoji to the wrapper
    this.renderer.appendChild(wrapperElement, emojiElement);

    // Append wrapper to the container
    this.renderer.appendChild(this.container, wrapperElement);

    // Create random horizontal offsets and set durations
    const randomX1 = (Math.random() - 0.5) * horizontalRange; // Horizontal range
    const randomX2 = (Math.random() - 0.5) * horizontalRange
    const randomY = this.container.offsetHeight - 150 - Math.random() * 50; // Vertical height (set as half of the container or up to 50px less)
    const horizontalDuration = (3 + Math.random() * 2) * this.timeMultiplier; // Horizontal animation duration
    const verticalDuration = 3 * this.timeMultiplier; // Vertical animation duration

    // Horizontal animation (applied to the emoji element)
    const animationNameX = `float-sideways-${Date.now()}`;
    const keyframesX = `
      @keyframes ${animationNameX} {
        0% {
          transform: translateX(0);
        }
        50% {
          transform: translateX(${randomX1}px);
        }
        100% {
          transform: translateX(${randomX2}px);
        }
      }
    `;

    // Vertical animation (applied to the wrapper element)
    const animationNameY = `float-up-${Date.now()}`;
    const keyframesY = `
      @keyframes ${animationNameY} {
        0% {
          transform: translateY(0);
          opacity: 1;
        }
        50% {
          opacity: 1;
        }
        100% {
          transform: translateY(-${randomY}px);
          opacity: 0;
        }
      }
    `;

    // Add keyframes to the DOM
    const styleElement = document.createElement('style');
    styleElement.textContent = keyframesX + keyframesY;
    document.head.appendChild(styleElement);

    // Apply animations
    this.renderer.setStyle(
      emojiElement,
      'animation',
      `${animationNameX} ${horizontalDuration}s ease-in-out infinite`
    );
    this.renderer.setStyle(
      wrapperElement,
      'animation',
      `${animationNameY} ${verticalDuration}s linear forwards`
    );

    // Clean up after animation ends
    setTimeout(() => {
      this.renderer.removeChild(this.container, wrapperElement); // Remove wrapper
      document.head.removeChild(styleElement); // Remove keyframes
    }, verticalDuration * 1000); // Cleanup based on vertical animation duration
  }

  onEmojiClick(name: string) {
    this.displayEmoji(name);

    if (!this.timeoutEmit) {
      this.timeoutEmit = setTimeout(() => {
        this.onSubmit.emit(name);
        this.timeoutEmit = null;
      }, 1000);
    }
  }
}
